// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2731":"5d4509681be176546243","2988":"5110bea0d3d14d88762f"}[chunkId] + ".js";
};